
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iETFY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $eEA8O = parcelRequire("eEA8O");


var $7aRa9 = parcelRequire("7aRa9");


var $3IBnw = parcelRequire("3IBnw");


var $cqmCC = parcelRequire("cqmCC");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");





var $7LI3Q = parcelRequire("7LI3Q");







var $8pZFw = parcelRequire("8pZFw");




const $8ef5dec28f0a8753$export$72fee3c5a4054046 = ({ cloudId: cloudId, onError: onError })=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [impersonationDetails, setImpersonationDetails] = (0, $42omo.useState)({
        loading: true,
        isImpersonating: false,
        targetUserId: null
    });
    (0, $42omo.useEffect)(()=>{
        const fetchImpersonationDetails = async ()=>{
            try {
                const response = await (0, $f7B1p.cfetch)(`/gateway/api/impersonation?targetId=${cloudId}`);
                const json = await response.json();
                setImpersonationDetails({
                    loading: false,
                    isImpersonating: json.isImpersonating,
                    targetUserId: json.isImpersonating ? json.targetUserId : null
                });
            } catch (e) {
                // Handling unauthenticated errors if session data cache is stale.
                // Handling rate limited errors since test users will bloat monitoring
                // and an on-call engineer can't do anything about rate limiting.
                if ((0, $7LI3Q.isUnauthorizedError)(e) || e instanceof (0, $8pZFw.RateLimitedError)) (0, $7Sm4c.markErrorAsHandled)(e);
                else onError(e);
            }
        };
        if (isLicensed) fetchImpersonationDetails();
    }, // We only want to fetch the endpoint on initial mount and not any other time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return impersonationDetails;
};


const $55f4134cdad172f0$var$i18n = (0, $h82at.defineMessages)({
    description: {
        id: "page-layout.impersonation-flag.description",
        defaultMessage: "You\u2019re temporarily logged in as another user. When you\u2019re done, <switchAction>switch back</switchAction> to your account."
    },
    title: {
        id: "page-layout.impersonation-flag.title",
        defaultMessage: "Impersonation active"
    },
    errorTitle: {
        id: "page-layout.impersonation-flag.error-title",
        defaultMessage: "Error"
    },
    errorDescription: {
        id: "page-layout.impersonation-flag.error-description",
        defaultMessage: "We couldn\u2019t switch back. Try again later, and if this keeps happening, try contacting <atlassianSupport>support</atlassianSupport>."
    }
});
const $55f4134cdad172f0$var$ImpersonationFlagComponent = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { flags: flags } = t0;
    const intl = (0, $1cfRh.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = (error)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.IMPERSONATION_FLAG_EXPERIENCE),
                error: error
            });
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const stopExperience = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = (reason)=>{
            experienceTracker.abort({
                name: (0, $irVI7.IMPERSONATION_FLAG_EXPERIENCE),
                reason: reason
            });
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const abortExperience = t2;
    let t3;
    if ($[4] !== experienceTracker) {
        t3 = ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.IMPERSONATION_FLAG_EXPERIENCE)
            });
        };
        $[4] = experienceTracker;
        $[5] = t3;
    } else t3 = $[5];
    const succeedExperience = t3;
    let t4;
    if ($[6] !== cloudId) {
        t4 = {
            cloudId: cloudId,
            onError: $55f4134cdad172f0$var$_temp
        };
        $[6] = cloudId;
        $[7] = t4;
    } else t4 = $[7];
    const { loading: loading, isImpersonating: isImpersonating, targetUserId: targetUserId } = (0, $8ef5dec28f0a8753$export$72fee3c5a4054046)(t4);
    let t5;
    if ($[8] !== abortExperience || $[9] !== flags || $[10] !== intl || $[11] !== stopExperience) {
        t5 = (error_1)=>{
            flags.showErrorFlag({
                id: "impersonation-flag-error",
                title: intl.formatMessage($55f4134cdad172f0$var$i18n.errorTitle),
                description: intl.formatMessage($55f4134cdad172f0$var$i18n.errorDescription, {
                    atlassianSupport: $55f4134cdad172f0$var$_temp2
                })
            });
            if ((0, $1uFM6.isUnauthorizedError)(error_1)) {
                (0, $7Sm4c.markErrorAsHandled)(error_1);
                abortExperience("Unauthorized to release impersonation");
            } else stopExperience(error_1);
        };
        $[8] = abortExperience;
        $[9] = flags;
        $[10] = intl;
        $[11] = stopExperience;
        $[12] = t5;
    } else t5 = $[12];
    const onReleaseError = t5;
    let t6;
    if ($[13] !== cloudId || $[14] !== onReleaseError || $[15] !== push || $[16] !== succeedExperience || $[17] !== targetUserId) {
        t6 = async ()=>{
            try {
                const response = await (0, $f7B1p.cfetch)(`/gateway/api/adminhub/um/site/${cloudId}/users/${targetUserId}/impersonate/release`, {
                    method: "POST"
                });
                const { link: link } = await response.json();
                succeedExperience();
                push(link);
            } catch (t7) {
                const error_2 = t7;
                onReleaseError(error_2);
            }
        };
        $[13] = cloudId;
        $[14] = onReleaseError;
        $[15] = push;
        $[16] = succeedExperience;
        $[17] = targetUserId;
        $[18] = t6;
    } else t6 = $[18];
    const dropImpersonation = t6;
    let t7;
    let t8;
    if ($[19] !== dropImpersonation || $[20] !== experienceTracker || $[21] !== flags || $[22] !== intl || $[23] !== isImpersonating || $[24] !== loading || $[25] !== succeedExperience) {
        t7 = ()=>{
            if (loading) return;
            if (isImpersonating) {
                experienceTracker.start({
                    name: (0, $irVI7.IMPERSONATION_FLAG_EXPERIENCE)
                });
                flags.showInfoFlag({
                    onClose: succeedExperience,
                    id: "impersonation-flag",
                    title: intl.formatMessage($55f4134cdad172f0$var$i18n.title),
                    description: intl.formatMessage($55f4134cdad172f0$var$i18n.description, {
                        switchAction: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                                appearance: "link",
                                spacing: "none",
                                onClick: dropImpersonation
                            }, chunks_0)
                    })
                });
            }
        };
        t8 = [
            loading,
            isImpersonating,
            flags,
            intl,
            succeedExperience,
            dropImpersonation,
            experienceTracker
        ];
        $[19] = dropImpersonation;
        $[20] = experienceTracker;
        $[21] = flags;
        $[22] = intl;
        $[23] = isImpersonating;
        $[24] = loading;
        $[25] = succeedExperience;
        $[26] = t7;
        $[27] = t8;
    } else {
        t7 = $[26];
        t8 = $[27];
    }
    (0, $42omo.useEffect)(t7, t8);
    return null;
};
const $55f4134cdad172f0$export$db9bc4eb9269556 = (0, $7aRa9.withFlags)($55f4134cdad172f0$var$ImpersonationFlagComponent);
function $55f4134cdad172f0$var$_temp(error_0) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error_0, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
}
function $55f4134cdad172f0$var$_temp2(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cqmCC.AtlassianSupportLink), null, chunks);
}
module.exports["ImpersonationFlag"] = $55f4134cdad172f0$export$db9bc4eb9269556;

});

parcelRegister("cqmCC", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $2Nwuj = parcelRequire("2Nwuj");

const $1805b22ab5ce9c71$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $1805b22ab5ce9c71$var$getLinkText = (showHostname)=>showHostname ? (0, $jiJCD.parse)($1805b22ab5ce9c71$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    });
const $1805b22ab5ce9c71$export$f1bb9e069c7d2c = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { showHostname: showHostname, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showHostname) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : $1805b22ab5ce9c71$var$getLinkText(showHostname);
        $[0] = children;
        $[1] = showHostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: $1805b22ab5ce9c71$export$98c2bfe563916273,
            target: "_blank"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["ATLASSIAN_SUPPORT_URL"] = $1805b22ab5ce9c71$export$98c2bfe563916273;
module.exports["AtlassianSupportLink"] = $1805b22ab5ce9c71$export$f1bb9e069c7d2c;

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});


//# sourceMappingURL=ImpersonationFlag.ea6386ae.js.map
